import ProductPurchaseEFT from '../Contents/PurchaseAction/ProductPurchaseEFT.vue'
export default {
  components: { ProductPurchaseEFT },
  data() {
    return {
      loadingPayment: false,
      paymentList: [],
    }
  },
  computed: {
    getEFT() {
      return this.paymentList.filter((p) => p.type === 3)
    },
  },
  methods: {
    async GET_PAYMENT_LIST() {
      this.loadingPayment = true
      const response = await this.$api.get('PaymentMethods')
      if (response.message === 'OK') this.paymentList = response.data
      else this.paymentList = []
      this.loadingPayment = false
    },
  },
  mounted() {
    this.GET_PAYMENT_LIST()
  },
}
